import { render } from "./ApeConstructorTitle.vue?vue&type=template&id=060566dd"
import script from "./ApeConstructorTitle.vue?vue&type=script&lang=js"
export * from "./ApeConstructorTitle.vue?vue&type=script&lang=js"

import "./ApeConstructorTitle.vue?vue&type=style&index=0&id=060566dd&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__